export enum GiftCardPaymentButtonType {
  GiftCard = 'GiftCard',
  NfcCard = 'NfcCard',
}
